import { capitalize, markRaw } from 'vue';

import {
  IconColoredCloudy,
  IconColoredRaining,
  IconColoredSnowing,
  IconColoredSunny,
  IconColoredTempHigh,
  IconColoredTempLow,
} from '@/common/icons/colored';
import i18n from '@/vueI18n';

export const allComparators = () => [
  { id: 'ABOVE', name: capitalize(i18n.global.t('states.above')) },
  { id: 'BELOW', name: capitalize(i18n.global.t('states.below')) },
];
export const allTemperatureLimits = () => [
  {
    id: 'DAILY_MAX',
    name: capitalize(i18n.global.t('options.temperatureLimits.high')),
    icon: markRaw(IconColoredTempHigh),
  },
  {
    id: 'DAILY_MIN',
    name: capitalize(i18n.global.t('options.temperatureLimits.low')),
    icon: markRaw(IconColoredTempLow),
  },
  {
    id: 'CURRENT',
    name: capitalize(i18n.global.t('options.temperatureLimits.current')),
    icon: markRaw(IconColoredTempHigh),
  },
];
export const allWeathers = () => [
  { id: 'SUNNY', name: capitalize(i18n.global.t('options.weather.clear')), icon: markRaw(IconColoredSunny) },
  { id: 'CLOUDY', name: capitalize(i18n.global.t('options.weather.cloudy')), icon: markRaw(IconColoredCloudy) },
  { id: 'RAINING', name: capitalize(i18n.global.t('options.weather.raining')), icon: markRaw(IconColoredRaining) },
  { id: 'SNOWING', name: capitalize(i18n.global.t('options.weather.snowing')), icon: markRaw(IconColoredSnowing) },
];
